/**
 * Font families available for text elements
 * This array can be used across multiple components for consistent font selection
 */
export const FONT_FAMILIES = [
  'Outfit',
  'Bricolage Grotesque',
  'Inter',
  'Dela Gothic One',
  'Arial',
  'Roboto',
  'Helvetica',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Poppins',
  'Raleway',
  'Ubuntu',
  'Playfair Display',
  'Merriweather',
  'Source Sans Pro',
  'Nunito',
  'Oswald',
  'Lora',
  'PT Sans',
  'Roboto Condensed',
  'Dancing Script',
  'Crimson Text',
  'Work Sans',
  'Fira Sans',
  'Cabin',
  'Libre Baskerville',
  'Quicksand',
  'Josefin Sans',
  'Bebas Neue',
  'Comfortaa',
  'Pacifico',
  'Cormorant Garamond',
  'Titillium Web',
  'Dosis',
  'Arimo',
  'Noto Sans',
  'Rubik',
  'Mukta',
  'Karla',
  'Varela Round',
  'Barlow',
  'Manrope',
  'Sora',
  'DM Sans',
  'Plus Jakarta Sans',
  'Space Grotesk',
  'Syne',
  'Epilogue',
  'Figtree',
  'Geist',
  'Geist Sans',
  'Geist Mono',
  'JetBrains Mono',
  'Fira Code',
  'Courier New',
  'Times New Roman',
  'Georgia',
  'Verdana',
  'Trebuchet MS',
  'Impact',
  'Comic Sans MS',
  'Tahoma',
  'Lucida Sans',
  'Palatino',
  'Garamond',
  'Book Antiqua',
  'Century Gothic',
  'Franklin Gothic Medium',
  'Copperplate',
  'Brush Script MT',
  'Lucida Console',
  'Monaco',
  'Consolas',
  'Menlo',
];

